/**
 * Funpaper brand theme — extracted from terusmengajar website-v3 style guide.
 * Source: tm-ai-workspace/resources/style-guide.md
 *
 * Funpaper = warm, child-friendly, content-first. Primary purple, cream
 * background, dark-purple text. Mobile-first. No 3D clay, no Tailwind.
 */

import '@/global.css';
import { Platform } from 'react-native';

export const Brand = {
  primary: '#563f7a',
  primaryDark: '#3d2c57',
  primaryLight: '#7a63a3',
  accent: '#ff8a3d',
  success: '#4caf50',
  danger: '#e53e3e',
  warning: '#f59e0b',
  /** Sky blue — a11y "Simpan" button (doc 05 §9.2 blue tint). */
  info: '#0ea5e9',
  /** Deep teal — "Biar Kami Pilih" escape-hatch button on home. */
  teal: '#0a7473',
  /** Gold — aksen ring/badge premium saja (bukan warna aksi). */
  gold: '#c9a227',
} as const;

export const Colors = {
  light: {
    text: '#201c23',
    textSecondary: '#6b6573',
    // Notion-style white — diganti dari cream #fcfbf8 (Fase 1 redesign)
    background: '#ffffff',
    card: '#ffffff',
    border: '#e5e5e5',
    primary: Brand.primary,
    accent: Brand.accent,
    success: Brand.success,
    danger: Brand.danger,
    warning: Brand.warning,
    info: Brand.info,
    teal: Brand.teal,
  },
  dark: {
    text: '#f5f3ee',
    textSecondary: '#a8a2b0',
    background: '#1a1525',
    card: '#241c33',
    border: '#2e2540',
    primary: Brand.primaryLight,
    accent: Brand.accent,
    success: Brand.success,
    danger: Brand.danger,
    warning: Brand.warning,
    info: Brand.info,
    teal: Brand.teal,
  },
} as const;

export type ThemeColor = keyof typeof Colors.light & keyof typeof Colors.dark;

export const Fonts = Platform.select({
  ios: {
    sans: 'system-ui',
    serif: 'ui-serif',
    rounded: 'ui-rounded',
    mono: 'ui-monospace',
  },
  default: {
    sans: 'normal',
    serif: 'serif',
    rounded: 'normal',
    mono: 'monospace',
  },
  web: {
    sans: 'var(--font-display)',
    serif: 'var(--font-serif)',
    rounded: 'var(--font-rounded)',
    mono: 'var(--font-mono)',
  },
});

export const Spacing = {
  half: 2,
  one: 4,
  two: 8,
  three: 16,
  four: 24,
  five: 32,
  six: 64,
  seven: 96,
} as const;

export const Radii = {
  small: 8,
  medium: 12,
  pill: 999,
} as const;

export const MaxContentWidth = 640;
